import { mapActions } from 'vuex'
// Relative imports (not the `@/` alias): the pre-commit hook lints newly
// ADDED files with `import/no-unresolved` as an error and no alias resolver.
import { getActiveTabByRouteName, ACTIVE_TAB } from '../utils/active-tab.utils'

/**
 * Syncs the Vuex `activeTabView` with the router and the `?tab=` deep link while the
 * hamburger flag is ON. When it is OFF, Tabs.vue is the only writer, so this stays inert.
 */
export default {
  computed: {
    tabQueryParam() {
      return this.$route.query.tab
    },
    isActiveTabSyncEnabled() {
      return this.$store.getters['featureToggles/canUseHamburgerMenu']
    },
  },
  watch: {
    '$route.name': {
      handler() {
        this.syncActiveTabFromRoute()
      },
      immediate: true,
    },
    tabQueryParam: {
      handler() {
        this.syncRouteFromTabQuery()
      },
      immediate: true,
    },
    isActiveTabSyncEnabled(enabled) {
      if (!enabled) return
      this.syncActiveTabFromRoute()
      this.syncRouteFromTabQuery()
    },
  },
  methods: {
    ...mapActions(['setActiveTabAction']),
    syncActiveTabFromRoute() {
      const routeName = this.$route.name
      if (!this.isActiveTabSyncEnabled || !routeName) return
      this.setActiveTabAction(getActiveTabByRouteName(routeName))
    },
    syncRouteFromTabQuery() {
      const value = this.tabQueryParam
      if (!this.isActiveTabSyncEnabled || !value) return
      const tab = getActiveTabByRouteName(value)

      // Determine the correct route name based on context
      let routeName = tab
      if (tab === ACTIVE_TAB.PROFILE) {
        // If we're on home route (no presentation id), use 'account' route
        // Otherwise use 'profile' route within presentation
        routeName = this.$route.params.id ? 'profile' : 'account'
      }

      this.$router.push({
        name: routeName,
        params: {
          id: this.$route.params.id,
        },
      })
    },
  },
}
